import { z } from 'zod';
import { InsurancePolicyTypeSchema } from '#/service/driver-management/model.ts';

const AccountSubscriptionSchema = z.object({
  id: z.string(),
  state: z.string(),
  startDateTime: z.iso.datetime({ offset: true }),
  endDateTime: z.iso.datetime({ offset: true }),
  productId: z.string(),
  willAutoRenew: z.boolean(),
  interval: z.string(),
  intervalCount: z.number(),
  subscriptionProvider: z.string(),
  plan: z.object({
    id: z.string(),
    name: z.string(),
    uniqueId: z.string(),
  }),
});

const AccountSchema = z.object({
  id: z.string(),
  email: z.string(),
  phoneNumber: z.string().nullish(),
  createDateTime: z.iso.datetime({ offset: true }),
  subscription: AccountSubscriptionSchema.optional(),
});

const PageExtraSchema = z.object({
  totalElement: z.number(),
  totalPage: z.number(),
});

const AccountListResponseSchema = z.object({
  data: z.array(AccountSchema),
  extra: PageExtraSchema,
});

const ResourceOwnerLinkSchema = z.object({
  id: z.string(),
  state: z.string(),
  linkDateTime: z.iso.datetime({ offset: true }).nullish(),
  unlinkDateTime: z.iso.datetime({ offset: true }).nullish(),
  resourceOwnerUserId: z.string().nullish(),
  point: z.object({
    id: z.string(),
    uniqueId: z.string(),
    name: z.string().nullish(),
    maximumPrice: z.number().nullish(),
    isDefaultDeduction: z.boolean(),
  }),
});

const ResourceOwnerLinkListResponseSchema = z.object({
  data: z.array(ResourceOwnerLinkSchema),
});

const InsuranceExpiryReminderSchema = z.object({
  id: z.string(),
  plateNumber: z.string(),
  policyType: InsurancePolicyTypeSchema,
  expiryDate: z.iso.date(),
  insurer: z.string().nullish(),
  source: z.string(),
  accountDocumentId: z.string().nullish(),
  state: z.string(),
});

const InsuranceExpiryReminderListResponseSchema = z.object({
  data: z.array(InsuranceExpiryReminderSchema),
});

type Account = z.infer<typeof AccountSchema>;
type AccountListResponse = z.infer<typeof AccountListResponseSchema>;
type ResourceOwnerLink = z.infer<typeof ResourceOwnerLinkSchema>;
type InsuranceExpiryReminder = z.infer<typeof InsuranceExpiryReminderSchema>;

export {
  AccountSchema,
  AccountListResponseSchema,
  ResourceOwnerLinkListResponseSchema,
  InsuranceExpiryReminderListResponseSchema,
};

export type {
  Account,
  AccountListResponse,
  InsuranceExpiryReminder,
  ResourceOwnerLink,
};
